import { render, staticRenderFns } from "./ClinicianPatientProgramsTable.vue?vue&type=template&id=38f60da3&scoped=true"
import script from "./ClinicianPatientProgramsTable.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientProgramsTable.vue?vue&type=script&lang=js"
import style0 from "./ClinicianPatientProgramsTable.vue?vue&type=style&index=0&id=38f60da3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f60da3",
  null
  
)

export default component.exports